import { CorporateViewTabGroup } from './CorporateViewTabGroup';
import { UscgMapLayout } from './UscgMapLayout';

export default function MapPage() {
  return (
    <div className="iap-response">
      <div className="maincontent-no-padding iap-response__main">
        <UscgMapLayout>
          <CorporateViewTabGroup
            currentMode={''}
            updateMode={() => {}}
            currentPhase={0}
          />
        </UscgMapLayout>
      </div>
    </div>
  );
}
